import { requestStatus } from '@promoboxx/redux-stores/src/lib/Utils'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { connect, actions, selectors } from '../../../stores'

const RenderChildren = ({ children, validRetailerAccount }) => {
  if (validRetailerAccount) {
    return children
  } else {
    return null
  }
}

RenderChildren.propTypes = {
  children: PropTypes.node,
  validRetailerAccount: PropTypes.bool,
}

//We call this the retailerAccountSelectorHandler, but then we mix in all this Brand related stuff.
//TODO: Suggestion is create a brandSelectorHandler that can optionally be combined with this for
//routes that need both. Maybe same component, but better isolation, or separate components, etc.
const RetailerAccountSelectorHandler = (props) => {
  const {
    brandsBySlugByRetailerAccountSlug,
    children,
    currentSlugs,
    getRetailerAccount,
    nonUserRetailerAccountsBySlug,
    userRetailerAccountsBySlug,
    retailerAccountSlugRequests,
    userIsInternal,
    setSelectedRetailerAccount,
    setSelectedBrand,
  } = props

  const match = useRouteMatch()

  const [validRetailerAccount, setValidRetailerAccount] = useState(false)
  let history = useHistory()

  useEffect(() => {
    const userRetailerAccount =
      userRetailerAccountsBySlug[match.params.retailerAccountSlug]
    const nonUserRetailerAccount =
      nonUserRetailerAccountsBySlug[match.params.retailerAccountSlug]

    let currentRetailerAccount = userRetailerAccount
    if (!currentRetailerAccount && userIsInternal) {
      currentRetailerAccount = nonUserRetailerAccount
    }
    if (currentRetailerAccount) {
      const currentBrand =
        brandsBySlugByRetailerAccountSlug[currentRetailerAccount.slug][
          match.params.brandSlug
        ]

      if (currentSlugs.retailerAccount !== match.params.retailerAccountSlug) {
        setSelectedRetailerAccount({
          id: currentRetailerAccount.id,
          skipUrlUpdate: true,
        })
        if (currentBrand) {
          setSelectedBrand({ id: currentBrand.id, skipUrlUpdate: true })
        }
      } else if (
        currentBrand &&
        match.params.brandSlug !== currentSlugs.brand
      ) {
        if (match.params.brandSlug !== 'all') {
          const userBrand =
            brandsBySlugByRetailerAccountSlug[currentRetailerAccount.slug][
              match.params.brandSlug
            ]
          if (userBrand) {
            props.setSelectedBrand({ id: userBrand.id, skipUrlUpdate: true })
          } else {
            props.setSelectedBrand({ id: null, skipUrlUpdate: true })
          }
        }
      }
      setValidRetailerAccount(true)
    } else if (userIsInternal && match.params.retailerAccountSlug) {
      let currentRequest =
        retailerAccountSlugRequests[match.params.retailerAccountSlug]
      if (!currentRequest) {
        getRetailerAccount({ id: match.params.retailerAccountSlug })
      } else if (currentRequest.requestStatus === requestStatus.rejected) {
        history.push('/retailer/accountSelector')
      }
    } else {
      history.push('/retailer/accountSelector')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    match.params.retailerAccountSlug,
    match.params.brandSlug,
    retailerAccountSlugRequests,
  ])

  //Rendering a whole new component let's us take advantage of memo here...
  return (
    <RenderChildren validRetailerAccount={validRetailerAccount}>
      {children}
    </RenderChildren>
  )
}

RetailerAccountSelectorHandler.propTypes = {
  brandsBySlugByRetailerAccountSlug: PropTypes.object,
  children: PropTypes.node,
  currentSlugs: PropTypes.object,
  getRetailerAccount: PropTypes.func,
  match: PropTypes.object,
  nonUserRetailerAccountsBySlug: PropTypes.object,
  retailerAccountIds: PropTypes.arrayOf(PropTypes.number),
  retailerAccountSlugRequests: PropTypes.object,
  setSelectedBrand: PropTypes.func,
  setSelectedRetailerAccount: PropTypes.func,
  userIsInternal: PropTypes.bool,
  userRetailerAccountsBySlug: PropTypes.object,
}

export const mapStateToProps = (state) => ({
  ...selectors.app.selectRetailerAccountsIds(state),
  ...selectors.app.selectCurrentRetailerAccountAndBrandSlug(state),
  ...selectors.app.selectUserIsInternal(state),
  ...selectors.brands.selectBrandsBySlugByRetailerAccountSlug(state),
  ...selectors.retailerAccounts.selectUserRetailerAccountsBySlug(state),
  ...selectors.retailerAccounts.selectNonUserRetailerAccountsBySlug(state),
  ...selectors.retailerAccounts.selectRetailerAccountSlugRequests(state),
})

export const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedRetailerAccount: (payload) =>
      dispatch(actions.app.selectRetailerAccount(payload)),
    setSelectedBrand: (payload) => dispatch(actions.app.selectBrand(payload)),
    getRetailerAccount: (payload) =>
      dispatch(actions.retailerAccounts.getRetailerAccount(payload)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RetailerAccountSelectorHandler)
